import logo from './assets/mcbr-logo-transparent.webp';

export default function App() {
  return (
    <main className="coming-soon">
      <div className="ambient ambient-one" aria-hidden="true" />
      <div className="ambient ambient-two" aria-hidden="true" />
      <div className="grid" aria-hidden="true" />

      <header className="brand">
        <img className="brand-logo" src={logo} alt="MCBR — Авто ключар и диагностика" />
      </header>

      <section className="hero" aria-labelledby="page-title">
        <div className="status">
          <span className="status-dot" aria-hidden="true" />
          Работим по новия ни сайт
        </div>

        <h1 id="page-title">
          Нещо добро
          <span> е на път.</span>
        </h1>

        <p className="intro">
          Подготвяме новото онлайн място на MCBR.
          <br />
          Скоро сайтът ще бъде готов.
        </p>

        <div className="progress" aria-label="Сайтът е в процес на разработка">
          <div className="progress-line"><span /></div>
          <div className="progress-labels">
            <span>В процес на разработка</span>
            <span>Очаквайте скоро</span>
          </div>
        </div>
      </section>

      <footer>
        <p>© {new Date().getFullYear()} MCBR</p>
        <p>Авто ключар и диагностика</p>
      </footer>
    </main>
  );
}
